import { Accordion, Box, Card, Divider, Heading, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { useWhoisMobileOptimizations } from '../../../../hooks/useWhoisMobileOptimizations';
import s from '../whoisResultsPage.scss';
const ShimmerRow = _ref => {
  let _ref$labelWidth = _ref.labelWidth,
    labelWidth = _ref$labelWidth === void 0 ? '120px' : _ref$labelWidth,
    _ref$valueWidth = _ref.valueWidth,
    valueWidth = _ref$valueWidth === void 0 ? '200px' : _ref$valueWidth;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP4",
    className: s.skeletonRow
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: labelWidth,
    height: "16px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: valueWidth,
    height: "16px"
  }));
};
export const WhoisSkeleton = _ref2 => {
  let domain = _ref2.domain;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const mobileOptimizations = useWhoisMobileOptimizations();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    className: mobileOptimizations ? undefined : s.whoisCard,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Card, null, !mobileOptimizations && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Header, {
    title: /*#__PURE__*/React.createElement(Heading, {
      size: "large",
      as: "h2"
    }, domain),
    subtitle: t('domain_search_gate.whois_results.info_card.subheader')
  }), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(SkeletonGroup, {
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "180px",
    height: "20px"
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(ShimmerRow, null), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "160px"
  }), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "180px"
  }), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "240px"
  }), !mobileOptimizations && /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "140px"
  })), mobileOptimizations && /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "100px",
    height: "16px"
  }))))), !mobileOptimizations && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(SkeletonGroup, {
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, t('domain_search_gate.whois_results.info_card.registrar_info.title')), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(ShimmerRow, null), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "280px"
  }), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "160px"
  }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(SkeletonGroup, {
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, t('domain_search_gate.whois_results.info_card.registrant_contact.title')), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(ShimmerRow, null), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "220px"
  }), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "180px"
  }), /*#__PURE__*/React.createElement(ShimmerRow, {
    valueWidth: "260px"
  }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: [{
      title: t('domain_search_gate.whois_results.accordion.raw_registry_data.title'),
      toggleIconPlacement: 'start',
      open: false,
      onToggle: () => {},
      children: /*#__PURE__*/React.createElement(React.Fragment, null)
    }]
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: [{
      title: t('domain_search_gate.whois_results.accordion.raw_registrar_data.title'),
      toggleIconPlacement: 'start',
      open: false,
      onToggle: () => {},
      children: /*#__PURE__*/React.createElement(React.Fragment, null)
    }]
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: "12px",
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Accordion, {
    items: [{
      title: t('domain_search_gate.whois_results.accordion.terms_of_service.title'),
      toggleIconPlacement: 'start',
      open: true,
      onToggle: () => {},
      children: /*#__PURE__*/React.createElement(SkeletonGroup, {
        className: s.skeletonGroup
      }, /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "SP3",
        padding: "SP4 0"
      }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
        className: s.skeleton,
        width: "100%",
        height: "14px"
      }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
        className: s.skeleton,
        width: "60%",
        height: "14px"
      })))
    }]
  })))))));
};
//# sourceMappingURL=WhoisSkeleton.js.map